import { render, staticRenderFns } from "./CollectionActPerformanceForDepartment.vue?vue&type=template&id=36d3ef18&scoped=true"
import script from "./CollectionActPerformanceForDepartment.vue?vue&type=script&lang=js"
export * from "./CollectionActPerformanceForDepartment.vue?vue&type=script&lang=js"
import style0 from "./CollectionActPerformanceForDepartment.vue?vue&type=style&index=0&id=36d3ef18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d3ef18",
  null
  
)

export default component.exports